import { ArticleFeatureValueDto } from './article-feature-value.dto';
import { ArticleTypeDto } from './article-type.dto';
import { ArticlesOnFamiliesDto } from './articles-on-damilies.dto';
import { AssessDto } from './assess.dto';
import { MachineMeasurementsValueDto } from './machine-measurements-value.dto';
import { MeasurementUnitDto } from './measurement-unit.dto';
import { PackagingDto } from './packaging.dto';

export class ArticleDto {
    id!: number;
    externalId?: number;
    name!: string;
    ean!: string;
    alias?: string;
    active!: boolean;
    batchControl!: boolean;
    externalReference!: string;
    useBatches?: boolean;
    usePackagings?: boolean;
    useSensors?: boolean;
    quantity!: number;
    measurementUnit!: MeasurementUnitDto;
    measurementUnitId?: number;
    packagings?: PackagingDto[];
    families?: ArticlesOnFamiliesDto[];
    familiesIds?: number[];
    articleType?: ArticleTypeDto;
    articleTypeId?: number;
    machineMeasurementsValues?: MachineMeasurementsValueDto[];
    articleFeatureValues?: ArticleFeatureValueDto[];
    isActive?: boolean;
    assess?: AssessDto[];
}
